import React from 'react';
import './Divider.scss';

interface DividerProps extends React.HTMLAttributes<HTMLHRElement> {}
export const Divider: React.FC<DividerProps> = () => (
  <hr className="lb_divider" />
);
